import { func, bool, string, node } from 'prop-types'

import { Typography, Notification } from '@telus-uds/components-web'

const GeneralMessage = ({ variant, dismissable, text, actions, onDismiss }) => {
  // Map TDS variant to UDS variant format
  const getUDSVariant = (tdsVariant) => {
    switch (tdsVariant) {
      case 'success':
        return { validation: 'success' }
      case 'error':
        return { validation: 'error' }
      case 'warning':
        return { validation: 'warning' }
      case 'branded':
      case 'info':
      default:
        return {}
    }
  }

  return (
    <Notification variant={getUDSVariant(variant)} dismissible={dismissable} onDismiss={onDismiss}>
      <Typography variant={{ size: 'medium' }}>
        {text}
        {actions}
      </Typography>
    </Notification>
  )
}

GeneralMessage.propTypes = {
  variant: string.isRequired,
  dismissable: bool,
  text: string.isRequired,
  actions: node,
  onDismiss: func
}

GeneralMessage.defaultProps = {
  dismissable: false,
  actions: undefined,
  onDismiss: undefined
}

export default GeneralMessage
